import MultiSelect from "react-multi-select-component";
import Multiselect from "multiselect-react-dropdown";
import Select from "react-select";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetClientActions,
  setShiftCreateActions,
  setClientBranchActions,
  setShiftRetrieveActions,
  SetShiftEditActions,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/Shift/ShiftCreate.scss";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { format } from "date-fns";
import { tr } from "date-fns/locale";
import "../../../StyleSheet/MainComponent/Shift/ShiftCreate.scss";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
// import { format } from "date-fns";


const ShiftCreateForm = (props) => {
  const { EditId, currentPage, client_id, setShow } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const [nameList3, setOptions3] = useState([]);
  const [MultiSelect2, setMuliselect2] = useState([]);
  const state = useSelector((state) => state);
  const [Client, setClient] = useState([]);
  const [ClientError, setClientError] = useState("");
  //  const [value, onChange] = useState('10:00');
  const [shifnameErr, setShiftName] = useState("");
  const [EncodedError, setEncodedError] = useState("");
  const [data, setData] = useState({
    startTime: "",
    EndTime: "",
    Client_id: client_id,
    Shift_name: "",
    encodeId: "",
    total_manpower: "",
  });
  const [value, setValue] = useState("");
  const [endtime, setEndTime] = useState("");
  const [startErr, setStartEr] = useState("");
  const [EndErr, setEndErr] = useState("");
  const Swal = require("sweetalert2");

  const [SelectMul, setSelectMul] = useState([]);
  const [Selectedval, setSelectedVal] = useState([]);
  const [endEditTime, setEndEdit] = useState("");
  const [StartEdit, setStartEdit] = useState("");


  ///-----------Client----------------
  useEffect(() => {
    const payloads = {
      search: "",
      page_size: 10,
      page: 1,
    };
    dispatch(setClientBranchActions(payloads));
    setClient(state.ClientBranch.ClientBranchess);
    if (state.ClientBranch.ClientBranchess != undefined) {
      console.log(state.ClientBranch.ClientBranchess, "clientslists");
    }
    // console.log(data, "asydgag");
    // console.log(state.ClientBranch.ClientBranchess.client_id, "states");
  }, []);
  ///----Retrieve---
  useEffect(() => {
    if (EditId != undefined && EditId != "") {
      const payload = {
        EditId: EditId,
      };
      dispatch(setShiftRetrieveActions(payload));
      // console.log(state.ShiftRetrieveData.ShiftRetrieve, "statess");
    }
  }, []);


  useEffect(() => {
    // console.log(value, endtime, "123123123");
    if (
      EditId != undefined &&
      EditId != "" &&
      state.ShiftRetrieveData.ShiftRetrieve.id
    ) {
      setEndTime(state.ShiftRetrieveData.ShiftRetrieve.end_time);
      //  console.log(endtime, "end time");

      // Input time string
      if (endtime != null) {
        //  const inputTime = "12-00-00";
        const inputTime = endtime;
        // Get the current date
        const currentDate = new Date();

        // Split the input time string

        if (inputTime != undefined && inputTime != null) {
          const [hours, minutes, seconds] = inputTime.split(":");

          // Set the hours, minutes, and seconds
          currentDate.setHours(hours);
          currentDate.setMinutes(minutes);
          currentDate.setSeconds(seconds);

          // Format the date as ISO string
          setEndEdit(currentDate);
        }
        // setEndEdit(currentDate.toISOString());

        // console.log(currentDate, "isostruing", typeof currentDate);
        // setEndTime(endEditTime)
        //console.log(endtime, "endtimessss");
      }

      setValue(state.ShiftRetrieveData.ShiftRetrieve.from_time);
      // console.log(
      //   state.ShiftRetrieveData.ShiftRetrieve.from_time,
      //   "from_time",
      //   value
      // );
      if (value != undefined && value != null) {
        const inputTime = value;
        // Get the current date
        const currentstart = new Date();

        // Split the input time string
        if (inputTime != undefined && inputTime != null) {
          const [hours, minutes, seconds] = inputTime.split(":");

          // Set the hours, minutes, and seconds
          currentstart.setHours(hours);
          currentstart.setMinutes(minutes);
          currentstart.setSeconds(seconds);

          setStartEdit(currentstart);



        }
      }
      if (value == undefined && value != null) {
        const inputTime = value;

        if (inputTime != undefined && inputTime == null) {
          // Get the current date
          const currentstart = new Date();

          // const [hours, minutes, seconds] = inputTime.split(":");

          // Set the hours, minutes, and seconds
          currentstart.setHours("00");
          currentstart.setMinutes("00");
          currentstart.setSeconds("00");

          setStartEdit(currentstart);
        }
      }

      /// console.log(endtime, "endtimes", state.ShiftRetrieveData.ShiftRetrieve);

      let objectZone = [];
      //   console.log(state.ShiftRetrieveData.ShiftRetrieve, "das");
      objectZone.push({
        value: state.ShiftRetrieveData.ShiftRetrieve.client_id.id,
        label: state.ShiftRetrieveData.ShiftRetrieve.client_id.client_name,
      });
      setSelectedVal(objectZone);
    }
  }, [state.ShiftRetrieveData.ShiftRetrieve, value, endtime]);

  ////------------___CLient
  const handleClients = (selectedVal) => {
    setMuliselect2(selectedVal);
    setData({
      ...data,
      Client_id: selectedVal.value,
    });
  };
  const handleChanged = (selectedVal) => {
    setSelectMul(selectedVal);
    setSelectedVal(selectedVal);
    setData({
      ...data,
      Client_id: selectedVal.value,
    });
  };

  ///----------Clients-------------
  useEffect(() => {
    const Datas = [];
    setClient(state.ClientBranch.ClientBranchess);
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      //  console.log(state.ClientBranch.ClientBranchess, "client");
      state.ClientBranch.ClientBranchess.forEach((element) => {
        // console.log(element.client_id                    ,"elementss", element);
        objectArray.push({ value: element.id, label: element.client_name });
      });

      setOptions3(objectArray);
    }
    // console.log(nameList3, "names");
  }, []);

  useEffect(() => {
    if (
      EditId != undefined &&
      state.ShiftRetrieveData.ShiftRetrieve.id != undefined
    ) {
      setData({
        ...data,
        Client_id: state.ShiftRetrieveData.ShiftRetrieve.client_id.id,
        Shift_name: state.ShiftRetrieveData.ShiftRetrieve.shift_name,
      });
      //console.log(data.Client_id, "idsss");
    }
  }, [state.ClientBranch]);

  // useEffect(() => {
  // if (
  // EditId != undefined &&
  // state.ShiftRetrieveData.ShiftRetrieve.id != undefined
  // ) {
  // setData({
  // ...data,
  // Shift_name: state.ShiftRetrieveData.ShiftRetrieve.shift_name,
  // });

  // }
  // }, [state.ClientBranch, data.Shift_name]);
  // console.log(state.ShiftRetrieveData.ShiftRetrieve, "ShiftRetrieve");
  useEffect(() => {
    if (
      EditId != undefined &&
      state.ShiftRetrieveData.ShiftRetrieve.id != undefined
    ) {
      setData({
        ...data,
        Shift_name: state.ShiftRetrieveData.ShiftRetrieve.shift_name,
        encodeId: state.ShiftRetrieveData.ShiftRetrieve.excel_code,
        total_manpower: state.ShiftRetrieveData.ShiftRetrieve.total_manpower ?? "",
      });
      //console.log(data.Client_id, "idsss");
    }
  }, [state.ShiftRetrieveData.ShiftRetrieve, EditId]);

  // console.log(data, "idsss");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndDifTime] = useState(null);
  const [startDiffErr, setStartErr] = useState("");
  const [endErr, setEndDIfErr] = useState("");
  // console.log(startDiffErr, endErr, startTime, endTime, "8 hours testing");

const HandleChanges = (e) => {
  const { name, value } = e.target;

  // Allow only letters, numbers, and space
  const cleanedValue = value.replace(/[^a-zA-Z0-9 ]/g, "");

  let limitedValue = cleanedValue;

  // Apply 20-character limit for specific fields
  if (name === "Shift_name" || name === "encodeId") {
    limitedValue = cleanedValue.slice(0, 20);
  }

  setData((prev) => ({
    ...prev,
    [name]: limitedValue,
  }));
};


  const handleStart = (newValue) => {
    setValue(newValue);
    setStartEr("");

    setStartTime(newValue);
    // validateTimes(newValue, endTime);
  };

  const HandleEndTime = (newValue) => {
    // Create a Date object
    // const currentDate = new Date(newValue);

    // // Get the time value in milliseconds
    // const timeInMilliseconds = currentDate.getTime();

    // console.log(timeInMilliseconds);

    setEndTime(newValue);
    setEndDifTime(newValue);
    setEndErr("");

    // validateTimes(startTime, newValue);
  };

// const validateTimes = (start, end) => {
//   if (start && end) {
//     const startDate = new Date(start);
//     const endDate = new Date(end);

//     const diffInHours = (endDate - startDate) / (1000 * 60 * 60);
// console.log(diffInHours ,"saduaposd diffInHours");

//     // // End time earlier than start time
//     // if (diffInHours < 0) {
//     //   // setStartErr("End time cannot be earlier than the start time.");
//     //   // setEndDIfErr("End time cannot be earlier than the start time.");
//     //   toast.error("End time cannot be earlier than the start time.");
//     //   return false;
//     // }

//     // Minimum 1 hour
//     if (diffInHours < 1) {
//         toast.error("The time difference must be at least 1 hour");

//       return false;
//     }


//     // No errors
//     // setStartErr("");
//     // setEndDIfErr("");
//     return true;
//   }

//   return false; // if start or end missing
// };

const validateTimes = (start, end) => {
  if (!start || !end) return false;

  const startDate = new Date(start);
  let endDate = new Date(end);

  // ✅ Night shift handling (PM → AM)
  if (endDate <= startDate) {
    endDate.setDate(endDate.getDate() + 1);
  }

  const diffInHours = (endDate - startDate) / (1000 * 60 * 60);
  console.log(diffInHours, "diffInHours");

  // Minimum 1 hour
  if (diffInHours < 1) {
    toast.error("The time difference must be at least 1 hour");
    return false;
  }

  return true;
};

  const HandleSubmits = (e) => {
    // console.log(data, "ad");

    const customDate = new Date(endtime);
    // console.log(endtime.$d, "times");
    // console.log(customDate.getHours(), "gettimes", customDate.getMinutes());
    // const formattedTime = `${customDate.getHours()}:${(customDate.getMinutes() < 10 ? '0' : '') + customDate.getMinutes()}`;

    const formattedTime = `${customDate.getHours()}:${customDate.getMinutes()}`;

    //  console.log("Formatted Time:", formattedTime);
    const start = new Date(value);
    const startTime = `${start.getHours()}:${start.getMinutes()}`;
    //  console.log(`${start.getHours()} :${start.getMinutes()}`, "Hours");
    // console.log(formattedTime, startTime, "asdasdasstartTime");

    // console.log(endtime, "endtime");

    if (EditId == undefined) {
      var a = 0;

            if(value && value != "" && endtime && endtime != ""){
             if (!validateTimes(value, endTime)) {
        a = 1;
       }
      }



if(!value || value == ""){
  setStartEr("*start time is required");
  a =1;
}

if(! endtime ||endtime == ""){
          setEndErr("*End time is required");
  a =1;
}

  const name = (data.Shift_name || "").trim().toLowerCase();

  // block Week Off / NF
  if (name === "week off" || name === "weekoff" || name === "wo"|| name === "off" || name === "nf") {
      a =1;
    setShiftName("Week Off and NF shift cannot be created.");
  }


 
      if (data.Shift_name == "") {
        setShiftName("*Shift is required");
        a = 1;
      }
      if (data.encodeId == "") {
        setEncodedError(" *Excel Code required");
        a = 1;
      }

      const code = (data.encodeId || "").trim().toLowerCase();

// block NF / OFF / WEEK OFF
if (
  code === "nf" ||
  code === "off" ||
  code === "week off" ||
  code === "weekoff"
) {
  a = 1;
  setEncodedError("NF / OFF / WEEK OFF cannot be used as Excel Code.");
}


      // if (data.Client_id == "") {
      //   setClientError("*Branch Name  is required");
      //   a = 1;
      // }

      // console.log(formattedTime , startTime ,"shift calculate 8 hours" , startTime+ formattedTime );
      if (a == 0) {
        Swal.fire({
          title: `Are you sure, do you want to  Create Shift ?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#234492",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.isConfirmed) {
            const payload = {
              data: data,
              // formattedEndTime: formattedTime == "NaN:NaN" ? null : formattedTime,
              // formattedTime: startTime == "NaN:NaN" ? null : formattedTime,
              formattedEndTime: formattedTime,
              formattedTime: startTime,

              currentPage: currentPage,
              EditId: EditId,
            };

            dispatch(setShiftCreateActions(payload, setShow(false)));
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.close();
          }
        });
      }
    }
  };

  const handleEdit = () => {
    console.log(endEditTime == "Invalid Date " ? "yes" : "noo", "endEditTime");
    if (EditId != undefined && EditId != "") {
      console.log(data, "datasss");
      var a = 0;
      // if (endtime == "") {
      //   setEndErr("*End time is required");
      //   a = 1;
      // }
      // if (value == "") {
      //   setStartEr("*start time is required");
      //   a = 1;
      // }
      if(StartEdit && StartEdit != "" && endEditTime && endEditTime != ""){
             if (!validateTimes(StartEdit, endEditTime)) {
        a = 1;
       }
      }
      if(!StartEdit || StartEdit == ""){
  setStartEr("*start time is required");
  a =1;
}

if(!endEditTime || endEditTime == ""){
          setEndErr("*End time is required");
  a =1;
}

      

  const name = (data.Shift_name || "").trim().toLowerCase();

  // block Week Off / NF
  if (name === "week off" || name === "weekoff" || name === "wo" || name === "nf") {
      a =1;
    setShiftName("Week Off and NF shift cannot be created.");
  }

      if (data.Shift_name == "") {
        setShiftName("*shift is required");
        a = 1;
      }
      if (data.encodeId == "") {
        setEncodedError(" *Excel Code required");
        a = 1;
      }

      const code = (data.encodeId || "").trim().toLowerCase();

// block NF / OFF / WEEK OFF
if (
  code === "nf" ||
  code === "off" ||
  code === "week off" ||
  code === "weekoff"
) {
  a = 1;
  setEncodedError("NF / OFF / WEEK OFF cannot be used as Excel Code.");
}


            if (a == 0) {
        const customDate = new Date(endEditTime);
        const formattedTime = `${customDate.getHours()}:${customDate.getMinutes()}`;
        const start = new Date(StartEdit);
        const startTime = `${start.getHours()}:${start.getMinutes()}`;
console.log(formattedTime ,"formattedTime oiasudasd", formattedTime ,StartEdit , endEditTime);

        Swal.fire({
          title: `Are you sure, do you want to  Edit Shift ?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#234492",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.isConfirmed) {
            const payload = {
              data: data,
              formattedEndTime: formattedTime,
              formattedTime: startTime,
              // formattedEndTime: formattedTime == "NaN:NaN" ? null : formattedTime,
              // formattedTime: startTime == "NaN:NaN" ? null : formattedTime,

              EditId: EditId,
            };
            dispatch(SetShiftEditActions(payload, setShow(false)));
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.close();
          }
        });
      }
    }
  };

  const handleSubmitsCancel = (e) => {
    Swal.fire({
      title: `Are you sure, do you want to exit  Shift ${
        EditId == undefined || EditId == "" ? "Create" : "Edit"
      } ?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        if (EditId != undefined && EditId != "") {
          // window.location.href = "/clientDetails";
          setShow(false);
        } else {
          setShow(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  return (
    <>
      <div className="Shift RoleCreatePopup">
        <div className="Shift ShiftCreatePopup">
          <div
            // className={`  ${stateDisplay ? " POPUP" : "outerPOPUP"}`}
            className="  BeforeSHIFTPopUp"
          >
            <div className=" BodyShiftContent  " style={{width:"46%", background:"transparent"}}>
              <div className="card" style={{background:"transparent" , border:"none"}}>
                <div className="card-body cards ">
                  <div className="UserPoup">
                    <div className="BeforForms">
                      <div className="Form">
                        <div className="ModalHeader" style={{background:"#234492", color:'#fff'}}>
                          {EditId == undefined || EditId == "" ? (
                            <span>Shift </span>
                          ) : (
                            <span>Shift </span>
                          )}
                          <div
                            className="CloseIcon"
                            onClick={(e) => setShow(false)}
                          >
                            <CloseOutlinedIcon />
                          </div>
                        </div>
                        <div className="Modal-Body">
                          <div className="row">
                            <div className="col mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Shift Name
                              </label>
                              <span style={{ color: "red" }}>*</span>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="Shift_name"
                                value={data.Shift_name}
                            
                                  onChange={(e) => {
    const val = e.target.value;
    const lower = val.trim().toLowerCase();

    if (["week off", "weekoff", "wo", "nf","off"].includes(lower)) {
      setShiftName("Week Off and NF shift cannot be created.");
      return; 
    }

    setShiftName("");       // clear error
    HandleChanges(e);       // your existing handler
  }}

                              />
                              <p className="Error"style={{fontSize:"13px"}}> {shifnameErr} </p>
                            </div>

                            <div className="col mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Excel Code
                              </label>
                              <span style={{ color: "red" }}>*</span>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="encodeId"
                                value={data.encodeId}
                                // onChange={(e) => {
                                //   HandleChanges(e);
                                //   setEncodedError("");
                                // }}
                                    onChange={(e) => {
      const val = e.target.value;
      const lower = val.trim().toLowerCase();

      // not allowed: NF, OFF, WEEK OFF
      if (["nf", "off", "week off", "weekoff"].includes(lower)) {
        setEncodedError("NF / OFF / WEEK OFF cannot be used as Excel Code.");
        return; // don't update state
      }

      setEncodedError("");
      HandleChanges(e); // your existing handler
    }}

                              />
                              <p className="Error" style={{fontSize:"13px"}}> {EncodedError} </p>
                            </div>

                      
                          </div>

                          <div className="row">
                            <div className="col-6 mt-3">
                              <label for="shiftTotalManpower" class="form-label">
                                Total Manpower
                              </label>
                              <input
                                type="number"
                                min="0"
                                step="1"
                                class="form-control"
                                id="shiftTotalManpower"
                                autocomplete="off"
                                name="total_manpower"
                                placeholder="People needed in this shift"
                                value={data.total_manpower}
                                onChange={(e) => {
                                  // whole numbers only; empty means not set
                                  if (/^\d{0,5}$/.test(e.target.value)) HandleChanges(e);
                                }}
                              />
                            </div>
                          </div>


                          {EditId == undefined || EditId == undefined ? (
                            <div className="row">
                              <div className="col mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Start Time
                                </label>
                                <span style={{ color: "red" }}>*</span>
                                <LocalizationProvider
                                
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DemoContainer components={["TimePicker"]}>
                                    <TimePicker
                                      // value={data.startTime}
                                      //onChange={e => { handleClients(e)}}
                                      value={value}
                                      onChange={(newValue) => {
                                        handleStart(newValue);
                                        setStartErr("");
                                      }}
                                      name="start"
                                   />
                                  </DemoContainer>
                                </LocalizationProvider>
                                <p className="Error" style={{fontSize:"13px"}}>{startErr}</p>
                                <p className="Error"style={{fontSize:"13px"}}>{startDiffErr}</p>
                              </div>

                              <div className="col mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  End Time
                                </label>
                                <span style={{ color: "red" }}>*</span>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  styles={{ width: "100%" }}
                                >
                                  <DemoContainer
                                    components={["TimePicker"]}
                                    value={data.startTime}
                                    styles={{ width: "100%" }}
                                  >
                                    <TimePicker
                                      styles={{ width: "100%" }}
                                      value={endtime}
                                      onChange={(newValue) => {
                                        HandleEndTime(newValue);
                                        setEndDIfErr("");


                                        
                                      }}
                                      name="startTime"
                                    />
                                  </DemoContainer>
                                </LocalizationProvider>
                                <p className="Error" style={{fontSize:"13px"}}>{EndErr}</p>
                                <p className="Error" style={{fontSize:"13px"}}>{endErr}</p>
                              </div>
                            </div>
                          ) : (
                            <div className="row">
                              <div className="col mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Start Time
                                </label>
                                <span style={{ color: "red" }}>*</span>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DemoContainer components={["TimePicker"]}>
                                    <TimePicker
                                      // value={data.startTime}
                                      //onChange={e => { handleClients(e)}}
                                      // value={value}
                                      value={StartEdit}
                                      onChange={(newValue) => {
                                        console.log(newValue ,"newValue");
                          
                                        setStartEdit(newValue);
                                        setStartEr("")
                                        setStartErr("");

                                        setStartTime(newValue);
                                        // validateTimes(newValue, endTime);


                                        setStartErr("");


                                    

                                      }}
                                      name="start"
                                    />
                                  </DemoContainer>
                                </LocalizationProvider>
                                <p className="Error" style={{fontSize:"13px"}}>{startErr}</p>
                                <p className="Error" style={{fontSize:"13px"}}>{startDiffErr}</p>

                              </div>

                              <div className="col mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  End Time
                                </label>
                                <span style={{ color: "red" }}>*</span>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  styles={{ width: "100%" }}
                                >
                                  <DemoContainer
                                    components={["TimePicker"]}
                                    styles={{ width: "100%" }}
                                  >
                                    <TimePicker
                                      styles={{ width: "100%" }}
                                      value={endEditTime}
                                      onChange={(newValue) => {
                                        setEndEdit(newValue);
                                        setEndDIfErr("");



                                        setEndDifTime(newValue);
                                        setEndErr("");
                                    
                                        // validateTimes(startTime, newValue);
                                        
                                        //  handleEDITPART(newValue)
                                        console.log(newValue, "newvaluess");
                                      }}
                                      name="startTime"
                                    />
                                  </DemoContainer>
                                </LocalizationProvider>
                                <p className="Error" style={{fontSize:"13px"}}>{EndErr}</p>
                                <p className="Error"style={{fontSize:"13px"}}>{endErr}</p>

                              </div>
                            </div>
                          )}
                          <div className="UserButtons">
                            <button
                              class="btn  SaveBtn"
                              type="submit"
                              onClick={(e) => {
                                HandleSubmits(e);
                                handleEdit(e);
                              }}
                            >
                              {EditId == undefined || EditId == ""
                                ? " Submit"
                                : "Update"}
                            </button>
                            <button
                              class="btn CancelBtn"
                              // onClick={(e) =>
                              // (window.location.href = "/clientDetails")
                              // }
                              onClick={(e) => {
                                handleSubmitsCancel(e);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShiftCreateForm;
